<template>
  <div class="game_countdown" v-if="current_step">
    <div class="game_countdown__step">
      {{ current_step }}
    </div>
  </div>
</template>

<script>
export default {
  name: "countdown",
  data() {
    return {
      current_step: ''
    }
  },
  props: {
    items: ''
  },
  methods: {
    async start() {
      await this.countDown(this.setStep);
    },
    async countDown(cb) {
      let arr = ['На старт!', 'Внимание', 'Марш!'];
      cb(arr[0]);
      for (let i = 1; i < 3; i++) {
        await this.sleep(1000);
        cb(arr[i]);
      }
      await this.sleep(1000);
      cb('');
    },

    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },

    setStep(currentStep) {
      this.current_step = currentStep;
      //this.step_key = 'ready';
      //this.playBeeSound('cif1');
    }
  },
  mounted() {
    this.start();
  }
}
</script>